import { produce } from 'immer';
import { wrapReducers } from '~/state/lib';

import INIT_STATE from './state';

const campaignReducer = {
  toggleEndCard: (state) => produce(state, (draft) => {
    draft.endCardEnabled = !draft.endCardEnabled;
  }),
  setBudget: (state, budget) => produce(state, (draft) => {
    draft.budget = budget;
  }),
  setAdLength: (state, length) => produce(state, (draft) => {
    draft.adLength = length;
  }),
  changeAdType: (state, type) => produce(state, (draft) => {
    draft.previousAdType = draft.adType;
    draft.adType = type;
  }),
  changeSearchId: produce((draft, id) => {
    draft.searchId = id;
  }),
  revertAdType: state => produce(state, (draft) => {
    draft.adType = draft.previousAdType;
    draft.previousAdType = null;
  }),
  changeAdName: produce((draft, name) => {
    draft.name = name;
  }),
  setInstagramAccount: produce((draft, account) => {
    draft.instagramAccount = account;
  }),
  linkAnalyzed: produce((draft, link) => {
    draft.link = link;
    draft.linkAnalyzed = true;
  }),
};

export default wrapReducers(campaignReducer, INIT_STATE);
